(function () {
  function initFAQSection(section) {
    if (!section || section.dataset.faqInitialized === 'true') {
      return;
    }

    section.dataset.faqInitialized = 'true';

    const questions = section.querySelectorAll('.faq-question');

    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        const answerId = question.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);

        if (!answer) return;

        const isOpen =
          question.getAttribute('aria-expanded') === 'true';

        /*
         * CLOSE CURRENT FAQ
         */
        if (isOpen) {
          question.setAttribute('aria-expanded', 'false');

          const currentHeight = answer.scrollHeight;

          answer.style.height = currentHeight + 'px';

          requestAnimationFrame(function () {
            answer.classList.remove('is-open');
            answer.style.height = '0px';
          });

          return;
        }

        /*
         * CLOSE ALL OTHER OPEN FAQs
         */
        questions.forEach(function (otherQuestion) {
          if (otherQuestion === question) return;

          const otherAnswerId =
            otherQuestion.getAttribute('aria-controls');

          const otherAnswer =
            document.getElementById(otherAnswerId);

          if (!otherAnswer) return;

          const otherIsOpen =
            otherQuestion.getAttribute('aria-expanded') === 'true';

          if (otherIsOpen) {
            otherQuestion.setAttribute(
              'aria-expanded',
              'false'
            );

            const currentHeight =
              otherAnswer.scrollHeight;

            otherAnswer.style.height =
              currentHeight + 'px';

            requestAnimationFrame(function () {
              otherAnswer.classList.remove('is-open');
              otherAnswer.style.height = '0px';
            });
          }
        });

        /*
         * OPEN CLICKED FAQ
         */
        question.setAttribute('aria-expanded', 'true');

        answer.classList.add('is-open');

        answer.style.height = '0px';

        const targetHeight = answer.scrollHeight;

        requestAnimationFrame(function () {
          answer.style.height = targetHeight + 'px';
        });
      });
    });
  }

  function initializeAllFAQSections() {
    document
      .querySelectorAll('.faq-section')
      .forEach(function (section) {
        initFAQSection(section);
      });
  }

  document.addEventListener(
    'DOMContentLoaded',
    initializeAllFAQSections
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section = event.target.querySelector
        ? event.target.querySelector('.faq-section')
        : null;

      if (section) {
        initFAQSection(section);
      }
    }
  );
})();